module.exports = __webpack_public_path__ + "static/img/szafa_12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_12.svg
// module id = W1c2
// module chunks = 0